import { tv } from 'tailwind-variants';

interface Props {
  className?: string;
  variant?: 'white' | 'black';
}

const loadingSpinner = tv({
  base: [
    'inline-block',
    'ml-2',
    'border-solid',
    'border-2',
    'rounded-full',
    'animate-spin',
    'duration-700',
    'ease-linear',
    'will-change-transform',
  ],
  variants: {
    size: {
      small: ['w-2.5', 'h-2.5'],
      primary: ['w-4', 'h-4'],
      large: ['size-16', 'border-4', 'ml-0'],
    },
    variant: {
      white: [
        'border-b-token-gray-200',
        'border-x-token-gray-200',
        'border-t-transparent',
        'text-special-content-button-primary-black',
      ],
      black: [
        'border-b-token-gray-1000',
        'border-x-token-gray-1000',
        'border-t-transparent',
        'text-token-gray-1600',
      ],
    },
  },
});

export const LoadingSpinner = ({ className, variant = 'black' }: Props) => {
  return <span className={loadingSpinner({ variant, size: 'small', class: className })} />;
};

export const LoadingSpinnerPrimary = ({ className, variant = 'black' }: Props) => {
  return <span className={loadingSpinner({ variant, size: 'primary', class: className })} />;
};

export const LoadingSpinnerLarge = ({ className, variant = 'black' }: Props) => {
  return <span className={loadingSpinner({ variant, size: 'large', class: className })} />;
};
